import { Tab, Tabs } from "react-bootstrap";
import { Suspense, useState } from "react";

import { AlertSettingsTitle, EducationLinksTitle, InsulinTypesTitle } from "../../util/const";
import LoadingSpinner from "../../Components/LoadingSpinner";
import EducationLinks from "./EducationLinks";
import InsulinTypes from "./InsulinTypes";
import AlertSettings from "./AlertSettings";


const Administration = () => {

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [key, setKey] = useState("alerts");
  
  return (
    <Tabs
      defaultActiveKey="alerts"
      id="admin-tab"
      className="mb-3" 
      onSelect={(k) => setKey(k!)}>
      <Tab eventKey="alerts" title={AlertSettingsTitle}>
        <Suspense fallback={<LoadingSpinner />}>
          <AlertSettings />
        </Suspense>
      </Tab>
      <Tab eventKey="links" title={EducationLinksTitle}>
        <Suspense fallback={<LoadingSpinner />}>
          <EducationLinks />
        </Suspense>
      </Tab>
      <Tab eventKey="insulins" title={InsulinTypesTitle}>
        <Suspense fallback={<LoadingSpinner />}>
          <InsulinTypes />
        </Suspense>
      </Tab>
    </Tabs>
  );
}

export default Administration;